import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(() =>
  createStyles({
    footer: {
      padding: '20px 40px',
    },
    link: {
      marginLeft: 5,
      'a': {
        color: 'grey'
      }
    }
  })
);